<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="51" fill="none">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M11 8v12M11 30v13M23 8v7M23 25v18M35 8v17M35 35v8M7 20a3 3 0 0 1 3-3h2a3 3 0 1 1 0 6h-2a3 3 0 0 1-3-3ZM19 25a3 3 0 0 1 3-3h2a3 3 0 1 1 0 6h-2a3 3 0 0 1-3-3ZM31 32a3 3 0 0 1 3-3h2a3 3 0 1 1 0 6h-2a3 3 0 0 1-3-3Z"/>
    </svg>
</template>